const Settingsconfig = {
    endpoints: {
        get: "/settings/show/",
        edit: "/settings/edit",
      },
    
};

export default Settingsconfig;
